import { render, staticRenderFns } from "./auth-layout.vue?vue&type=template&id=3a945228&scoped=true&"
import script from "./auth-layout.vue?vue&type=script&lang=js&"
export * from "./auth-layout.vue?vue&type=script&lang=js&"
import style0 from "./auth-layout.vue?vue&type=style&index=0&id=3a945228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a945228",
  null
  
)

export default component.exports